import {AppUrls} from 'shared/config/model/urls';

import React from 'react';
import {Link} from 'react-router-dom';
import {t} from '@lingui/core/macro';
import cn from 'classnames';

import {isTranslate} from 'shared/lib/lang';

import styles from './NotificationLimitInfo.module.scss';

interface INotificationLimitInfoProps {
    current: number;
    limit: number;
    className?: string;
}

const NotificationLimitInfo: React.FC<INotificationLimitInfoProps> = ({current, limit, className}) => {
    const isExceeded = limit > 0 && current >= limit;

    return (
        <div className={cn(styles.container, className)}>
            <span className={styles.count}>
                {t`Использовано`} {current} {t`из`} {limit}
            </span>
            {isExceeded && (
                <Link
                    to={isTranslate() ? AppUrls.PRICING : AppUrls.TARIFFS}
                    className={cn(styles.link, styles.colorLink)}
                >
                    {t`Улучшить тарифный план`}
                </Link>
            )}
        </div>
    );
};

export default NotificationLimitInfo;
